import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ChannelIcon from 'components/Utils/ChannelIcon'
import { getChannelLabel } from 'data/channels/helpers'

import SearchBox from './SearchBox'

export default function ChannelList(props) {
  const {
    style,
    channelList,
    activeChannelId,
    onChannelSelected,
    displaySearchBox,
  } = props
  const [filter, setFilter] = React.useState('')

  const channels = React.useMemo(
    () =>
      channelList.filter(channel =>
        getChannelLabel(channel)
          .toLowerCase()
          .includes(filter.toLowerCase())
      ),
    [channelList, filter]
  )

  return (
    <React.Fragment>
      {displaySearchBox && (
        <SearchBox
          placeholder={'Search channels...'}
          onChange={event => setFilter(event.target.value)}
          value={filter}
        />
      )}
      <div className="scroll-y" style={style}>
        {channels.map((channel, index) => {
          const isActive = activeChannelId && channel.id === activeChannelId

          return (
            <div
              onClick={() => onChannelSelected(channel)}
              className={classNames(
                [
                  'flexbox flexbox-row flexbox-align-center',
                  'pointer transition',
                  'padding-normal',
                  'font-weight-large',
                ],
                isActive
                  ? 'background-primary shade-100'
                  : 'background-shade-50-on-focus background-shade-50-on-hover'
              )}
              key={channel.id}
            >
              <div className="margin-right-normal shade-30">
                <ChannelIcon useNewIcons size={12} channel={channel} />
              </div>
              <div
                className="ellipsis fs-block data-hj-suppress" /* fs-block & data-hj-suppress hides content for FullStory & Hotjar */
              >
                {getChannelLabel(channel)}
              </div>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}

ChannelList.propTypes = {
  style: PropTypes.object,
  channelList: PropTypes.array.isRequired,
  activeChannelId: PropTypes.string,
  onChannelSelected: PropTypes.func,
  displaySearchBox: PropTypes.bool,
}

ChannelList.defaultProps = {
  style: {},
  channelList: [],
  activeChannelId: '',
  onChannelSelected: () => {},
  displaySearchBox: false,
}
